import React from 'react';
import { FileText, Zap, ShieldCheck } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="relative bg-white pt-20 sm:pt-28 pb-10 sm:pb-16 overflow-hidden" data-id="element-79">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center flex flex-col items-center" data-id="element-80">
        {/* Main Title */}
        <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-gray-900 leading-[1.1] mb-2 sm:mb-4" data-id="element-81">
          Todo tu año de <br className="sm:hidden" data-id="element-82" />
          Geografía{' '}
          <em className="text-[#16a34a] not-italic font-black italic" data-id="element-83">
            resuelto.
          </em>
        </h1>

        {/* Product Mockup */}
        <div className="w-full max-w-xs sm:max-w-md md:max-w-lg my-4 sm:my-6 cursor-pointer transform hover:scale-105 transition-transform duration-300" onClick={scrollToOffer} data-id="element-84">
          <img src="https://cdn.magicpatterns.com/uploads/eCDgi54Sbbi4qSmorPopP3/mockups_geografia_.png" alt="Kit Completo Geografía Lista Mockup" className="w-full h-auto drop-shadow-2xl animate-float" data-id="element-85" />
        </div>

        {/* Green italic subtitle */}
        <p className="text-[#16a34a] text-lg sm:text-2xl md:text-3xl font-semibold italic mb-3 sm:mb-4" data-id="element-86">
          "Listo para usar. Sin buscar más."
        </p>

        {/* Description */}
        <p className="text-sm sm:text-lg text-gray-600 max-w-2xl mx-auto mb-4 sm:mb-6 leading-relaxed" data-id="element-87">
          El sistema que usan docentes de Geografía de secundaria en Argentina
          para planificar{' '}
          <span className="font-bold text-gray-900 underline underline-offset-2 decoration-[#16a34a]" data-id="element-88">
            todo el año en una tarde
          </span>
        </p>

        {/* Trust badges — single line, highlighted */}
        <div className="flex items-center justify-center gap-2 sm:gap-3 text-gray-700 text-xs sm:text-sm font-semibold mb-5 sm:mb-7 bg-gray-100 rounded-full px-4 sm:px-6 py-2 sm:py-2.5 border border-gray-200" data-id="element-89">
          <span className="flex items-center gap-1" data-id="element-90">
            <FileText className="h-4 w-4 text-[#16a34a]" data-id="element-91" />
            100% PDF
          </span>
          <span className="text-gray-300" data-id="element-92">•</span>
          <span className="flex items-center gap-1" data-id="element-93">
            <Zap className="h-4 w-4 text-[#16a34a]" data-id="element-94" />
            Acceso Inmediato
          </span>
          <span className="text-gray-300" data-id="element-95">•</span>
          <span className="flex items-center gap-1" data-id="element-96">
            🇦🇷 Currículo argentino
          </span>
        </div>

        {/* Main CTA */}
        <button onClick={scrollToOffer} className="inline-flex items-center justify-center bg-[#16a34a] hover:bg-green-700 text-white text-base sm:text-xl font-black py-4 sm:py-5 px-8 sm:px-14 rounded-xl shadow-[0_4px_20px_rgba(22,163,74,0.4)] transition-all transform hover:-translate-y-1 uppercase tracking-wide w-full sm:w-auto max-w-lg" data-id="element-97">
          → QUIERO MI KIT COMPLETO AHORA
        </button>

        {/* Trust line — highlighted */}
        <div className="flex items-center justify-center gap-2 sm:gap-4 mt-3 sm:mt-4 bg-green-50 rounded-full px-4 sm:px-6 py-2 border border-green-100" data-id="element-98">
          <span className="flex items-center gap-1 text-green-700 text-[10px] sm:text-xs font-semibold" data-id="element-99">
            ✅ Garantía 7 días
          </span>
          <span className="text-green-300" data-id="element-100">•</span>
          <span className="flex items-center gap-1 text-green-700 text-[10px] sm:text-xs font-semibold" data-id="element-101">
            🔒 Pago 100% seguro
          </span>
          <span className="text-green-300" data-id="element-102">•</span>
          <span className="flex items-center gap-1 text-green-700 text-[10px] sm:text-xs font-semibold" data-id="element-103">
            💳 Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}